.section {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.content {
    display: flex;
    flex-direction: column;
    gap: 12px;
}
